import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Layout = () => {
  const { customer, logout } = useAuth();
  const location = useLocation();

  const navClass = (path) =>
    `text-sm font-medium ${
      location.pathname.startsWith(path) ? 'text-teal-800' : 'text-slate-600 hover:text-teal-700'
    }`;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <span className="font-semibold text-teal-800">Cleaning</span>
            <nav className="flex gap-4">
              <Link to="/dashboard" className={navClass('/dashboard')}>
                Home
              </Link>
              <Link to="/requests" className={navClass('/requests')}>
                My requests
              </Link>
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-slate-500 hidden sm:inline">{customer?.email}</span>
            <button type="button" onClick={logout} className="text-sm text-slate-600 hover:text-teal-800">
              Log out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
